import React from 'react'
import s from './index.module.css'

export const ColorBox = ({color, onClick, title}) => (
  <div onClick={onClick} className={s.size} style={{backgroundColor: color}} title={title}/>
)
